import { MdCheck } from 'react-icons/md';

export function HistoryCheck() {
  return (
    <div className="-mt-0.5 flex items-center">
      <MdCheck className="text-neutral-700" />
    </div>
  );
}
